/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const base_chain_about = () => `Base, an Ethereum-based blockchain developed by Coinbase, operates as a Layer 2 (L2) network, leveraging Optimism to provide a secure, cost-effective, and user-friendly environment for decentralized application (dApp) development. With a mission to onboard the next billion users to web3, Base ensures near-zero fees, quick transactions, and robust security supported by Ethereum's infrastructure. At its launch, Base had over 100 dApps and service providers, aiming to solve the blockchain trilemma by prioritizing interoperability and composability among participating rollups. This approach enhances scalability while preserving security and decentralization.`
